module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-inox-brushed-4049-scale.6301077d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-inox-brushed-4049-scale.jpg
// module id = 1117
// module chunks = 37